import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import moment from 'moment-timezone';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactModal from 'react-modal';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './StreamingWarningModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class StreamingWarningModal extends Component {
    constructor(props) {
        super(props);
    }

    toggle = (type: string) => {
        this.props.toggleStreamingWarningModal(type);
    };

    render() {
        return (
            <div>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.props.isVODWarning}
                    role={
                        "dialog"
                    }
                    contentLabel={strings.titleVOD}
                >
                    <button className="showtix-modal__close" onClick={() => this.toggle('vod')} aria-label="Close the modal">&times;</button>
                    <h4 className="modal-title text-center">{strings.titleVOD}</h4>
                    {this.props.selectedEvent.venue && (
                        <React.Fragment>
                            <p>{strings.formatString(strings.descriptionVOD,moment(this.props.selectedDate.redeem_start).format('LLLL').toString(),moment(this.props.selectedDate.redeem_end).format('LLLL').toString(),this.props.selectedEvent.venue.timezone)}</p>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: strings.descriptionVOD2
                                }}
                            />
                        </React.Fragment>
                    )}
                    <div className="d-flex justify-content-center">
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={() => this.toggle('vod')}
                        >{strings.ok}</button>
                    </div>
                </ReactModal>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.props.isLiveStreamingWarning}
                    role={
                        "dialog"
                    }
                    contentLabel={strings.titleLive}
                >
                    <button className="showtix-modal__close" onClick={() => this.toggle('live')} aria-label="Close the modal">&times;</button>
                    <h4 className="modal-title text-center">{strings.titleLive}</h4>
                    {ReactHtmlParser(strings.descriptionLive)}
                    <div className="d-flex justify-content-center">
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={() => this.toggle('live')}
                        >{strings.ok}</button>
                    </div>
                </ReactModal>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.props.isScheduledContentWarning}
                    role={
                        "dialog"
                    }
                    contentLabel={strings.titleScheduled}
                >
                    <button className="showtix-modal__close" onClick={() => this.toggle('scheduled')} aria-label="Close the modal">&times;</button>
                    <h4 className="modal-title text-center">{strings.titleScheduled}</h4>
                    {ReactHtmlParser(strings.descriptionScheduled)}
                    <div className="d-flex justify-content-center">
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={() => this.toggle('scheduled')}
                        >{strings.ok}</button>
                    </div>
                </ReactModal>
            </div>
        );
    }
}

StreamingWarningModal.propTypes = {
    isVODWarning: PropTypes.bool,
    isLiveStreamingWarning: PropTypes.bool,
    isScheduledContentWarning: PropTypes.bool,
    toggleStreamingWarningModal: PropTypes.func,
    selectedDate: PropTypes.object,
    selectedEvent: PropTypes.object,
};

export default StreamingWarningModal;


// WEBPACK FOOTER //
// ./src/components/EventListing/StreamingWarningModal/StreamingWarningModal.js